import { appColors, appFonts, fontSize, useFontSize } from "./appTheme"
import { commonHeaderStyle } from "./shared/commonComponents/commonHeaderStyle"
import { signInStyle } from "./components/auth/signInStyle"
import { commonDialogBoxStyle } from "./shared/commonComponents/commonDialogBoxStyle"
import { pinStyle } from "./components/auth/pinStyle"
import { productListStyle } from "./components/products/productList/productListStyle"
import { addEditProductStyle } from "./components/products/addEditProduct/addEditProductStyle"
import { modifierOptionsStyle } from "./components/products/modifiers/modifierOptionsStyle"
import { modifierSetStyle } from './components/products/modifiers/modifierSetStyle'
import { SplashStyle } from "./splashStyle"
import { CategoryListStyle } from "./components/category/categoryListStyle"
import { manualDiscountStyle } from "./components/discounts/manualDiscountStyle"
import { PayXGetFreeStyle } from "./components/discounts/payXGetFreeStyle"
import { customerListStyle } from "./components/customers/customerListStyle"
import { printCustomerStyle } from "./components/customers/printCustomerStyle"
import { viewDiscountStyle } from "./components/discounts/viewDiscountStyle"
import { addEditCustomerStyle } from "./components/customers/addEditCustomerStyle"
import { automaticDiscountListStyle } from "./components/discounts/automaticDiscountListStyle"
import { customerHistoryStyle } from "./components/customers/customerHistoryStyle"
import { TipSettingsStyle } from "./components/settings/tipSettingsStyle"
import { DisplaySettingsStyle } from "./components/settings/displaySettingsStyle"
import { taxListStyle } from "./components/tax/taxListStyle"
import { LocationStyle } from "./components/location/locationStyle"
import { receiptSettingsStyle } from "./components/settings/receiptSettingsStyle"
import { productDetailsStyle } from "./components/sellScreen/productDetailsStyle"
import { inventoryAdjustmentHistoryStyle } from "./components/products/addEditProduct/inventoryAdjustmentHistoryStyle"
import { notificationSettingStyle } from "./components/settings/notificationSettingStyle"
import { PluginStyle } from "./components/plugins/pluginStyle"
import { RegisterStyle } from "./components/register/registerStyle"
import { sellScreenStyle } from "./components/sellScreen/sellScreenStyle"
import { sellScreenProductsStyle } from "./components/sellScreen/sellScreenProductsStyle"
import { sellScreenPaymentStyle } from "./components/sellScreen/sellScreenPaymentStyle"
import { sellScreenCheckoutStyle } from "./components/sellScreen/sellScreenCheckoutStyle"
import { purchaseOrderListStyle } from "./components/purchaseOrder/purchaseOrderListStyle"
import { sellScreenSummaryStyle } from "./components/sellScreen/sellScreenSummaryStyle"
import { paymentSettingStyle } from "./components/settings/paymentSettingStyle"
import { addEditTimeCardStyle } from "./components/timeCard/addEditTimeCardStyle"
import { timeCardListStyle } from "./components/timeCard/timeCardListStyle"
import { totalHoursWorkedStyle } from "./components/timeCard/totalHoursWorkedStyle"
import { viewTotalHoursWorkedStyle } from "./components/timeCard/viewTotalHoursWorkedStyle"
import { customerGroupsListStyle } from "./components/customerGroups/customerGroupsListStyle"
import { addEditCustomerGroupsStyle } from "./components/customerGroups/addEditCustomerGroupsStyle"
import { paymentListStyle } from "./components/payment/paymentListStyle"
import { VendorStyle } from "./components/vendor/vendorStyle"
import { createPaymentStyle } from "./components/payment/createPaymentStyle"
import { CommentHistoryStyle } from "./shared/commonComponents/commentHistoryStyle"
import { BillingStyle } from "./components/profile/billingsStyle"
import { myAccountStyle } from "./components/profile/myAccountStyle"
import { roleStyle } from "./components/role/roleStyle"
import { invitedStaffStyle } from "./components/role/invitedStaffStyle"
import { printMembershipCardStyle } from "./components/customers/printMembershipCardStyle"
import { viewProductDetailsStyle } from "./components/sellScreen/viewProductDetailsStyle"
import { createVendorCreditsStyle } from "./components/vendor/createVendorCreditsStyle"
import { vendorCreditsStyle } from "./components/vendor/vendorCreditsStyle"
import { brandListStyle } from "./components/brands/brandListStyle"
import { storeSettingsStyle } from "./components/settings/storeSettingStyle"
import { customEmailNotificationStyle } from "./components/settings/customEmailNotificationStyle"
import { preferenceSettingStyle } from "./components/settings/preferenceSettingStyle"
import { optionListStyle } from "./components/products/option/optionListStyle"
import { addEditOptionStyle } from "./components/products/option/addEditOptionStyle"
import { sortOptionListStyle } from "./components/products/option/sortOptionListStyle"

import { allProductsStyle } from "./components/brands/allProductsStyle"
import { zoneListStyle } from "./components/settings/zoneListStyle"
import { addEditZoneStyle } from "./components/settings/addEditZoneStyle"
import { InventoryStyle } from "./components/products/inventory/inventoryStyle"
import { storeImageGalleryStyle } from "../components/products/imageGallery/storeImageGallery.style"
import { useAppSelector } from "../redux/hooks"
import { applyWebStyleOverrides } from "./webOverrides"
import { dashboardStyles } from "./components/dashboard/dashboard.style"
import { quickProductEditStyle } from "./components/products/productList/quickProductEdit.style"
import { staffListStyle } from "./components/staff/staffList.style"
import { readymadeProductsStyle } from "./components/products/productList/readymadeProductsStyle"
import { productSettingsStyle } from "./components/settings/productSettingsStyle"
import { printProductLabelsStyle } from "./components/products/productList/printProductLabelsStyle"
import { bulkEditStyle } from "./components/products/productList/bulkEditStyle"
import { receiptSettingsScreenStyle } from "./components/settings/receiptSettingsScreenStyle"

export type AppTheme = ReturnType<typeof useFontSize> & typeof appColors & typeof appFonts
export const useThemeSelection = () => {
    const isLandscape = useAppSelector((state) => state.common.isLandscape)
        const fontSize = useFontSize(isLandscape)
        const theme = { ...fontSize, ...appColors, ...appFonts }
        return applyWebStyleOverrides({
                ...theme,
                commonHeaderStyle,
                signInStyle,
                commonDialogBoxStyle,
                pinStyle,
                productListStyle: productListStyle(theme),
                SplashStyle,
                CategoryListStyle,
                modifierOptionsStyle,
                modifierSetStyle,
                addEditProductStyle: addEditProductStyle(theme),
                manualDiscountStyle: manualDiscountStyle(theme),
                PayXGetFreeStyle,
                customerListStyle,
                printCustomerStyle,
                addEditCustomerStyle,
                viewDiscountStyle,
                automaticDiscountListStyle: automaticDiscountListStyle(theme),
                TipSettingsStyle,
                DisplaySettingsStyle,
                customerHistoryStyle,
                taxListStyle,
                productDetailsStyle,
                LocationStyle,
                receiptSettingsStyle,
                inventoryAdjustmentHistoryStyle,
                notificationSettingStyle,
                PluginStyle,
                RegisterStyle,
                sellScreenStyle,
                sellScreenProductsStyle,
                sellScreenCheckoutStyle,
                purchaseOrderListStyle,
                sellScreenSummaryStyle,
                sellScreenPaymentStyle,
                paymentSettingStyle,
                addEditTimeCardStyle,
                timeCardListStyle: timeCardListStyle(theme),
                totalHoursWorkedStyle,
                viewTotalHoursWorkedStyle,
                customerGroupsListStyle,
                addEditCustomerGroupsStyle,
                paymentListStyle,
                VendorStyle,
                CommentHistoryStyle,
                createPaymentStyle,
                BillingStyle,
                myAccountStyle,
                roleStyle,
                invitedStaffStyle,
                viewProductDetailsStyle,
                vendorCreditsStyle,
                createVendorCreditsStyle,
                printMembershipCardStyle,
                brandListStyle,
                storeSettingsStyle,
                customEmailNotificationStyle,
                preferenceSettingStyle,
                optionListStyle,
                addEditOptionStyle,
                sortOptionListStyle,
                allProductsStyle,
                zoneListStyle,
                addEditZoneStyle,
                InventoryStyle,
                storeImageGalleryStyle,
                quickProductEditStyle: quickProductEditStyle(theme),
                staffListStyle: staffListStyle(theme),
                dashboardStyles: dashboardStyles(theme),
                readymadeProductsStyle: readymadeProductsStyle(theme),
                productSettingsStyle: productSettingsStyle(theme),
                printProductLabelsStyle: printProductLabelsStyle(theme),
                bulkEditStyle: bulkEditStyle(theme),
                receiptSettingsScreenStyle: receiptSettingsScreenStyle(theme)
        })
}